"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'ButtonTabGroup');

function ButtonTabGroup(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      buttons = _ref.buttons,
      onChange = _ref.onChange,
      value = _ref.value,
      disabled = _ref.disabled,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "buttons", "onChange", "value", "disabled"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, ButtonTabGroup.overrides);
  var rootClassName = (0, _classnames2.default)(classes.root, classNameProp);
  var buttonsEl = (0, _react.useMemo)(function () {
    return buttons.reduce(function (array, button, idx) {
      var buttonClassName = (0, _classnames2.default)(classes.button, (0, _defineProperty2.default)({}, classes.active, button.value === value)); // not first or last

      if (idx && idx < buttons.length) array.push( /*#__PURE__*/_react.default.createElement("span", {
        key: "".concat(idx).concat(button.value),
        className: classes.divider
      }));
      array.push( /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
        key: button.value,
        className: buttonClassName,
        onClick: function onClick() {
          return onChange && onChange(button.value);
        }
      }, override.button), button.label));
      return array;
    }, []);
  }, [buttons, classes.active, classes.button, classes.divider, onChange, override.button, value]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: rootClassName
  }, override.root), buttonsEl);
}

ButtonTabGroup.overrides = ['root', 'button'];
ButtonTabGroup.defaultProps = {
  buttons: [],
  overrides: {}
};
process.env.NODE_ENV !== "production" ? ButtonTabGroup.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.any
  })),
  onChange: _propTypes.default.func,
  value: _propTypes.default.any
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(ButtonTabGroup);

exports.default = _default;